module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAAAdElEQVR4AWOgE5gKRMzM0/j5ZwNJIIKI/GNgQEFoGtTVl86ceXXy5EtycgsJaxASmjNnzrU/f/79/Pl3woSLQKsI29Defhao+tu339XVJwjYAPGAhMT8lpYzdXUnRUXnEdYAQZycMyE+JqDhHw40LDUMUgAAjj+ay8iG4JsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/TW.png
// module id = 1288
// module chunks = 0